<div class="apa-card">
  <div class="apa-title">{{ data?.title || 'APA RANGES' }}</div>
  <div class="apa-grid" *ngIf="rows.length; else emptyState">
    <div class="apa-row" *ngFor="let row of rows">
      <div class="label">{{ row.label }}</div>
      <label class="boundary min" aria-label="Minimum percentage">
        <input
          class="boundary-input"
          type="number"
          [(ngModel)]="row.min"
          [step]="getStep(row)"
          (ngModelChange)="onBoundaryChange(row, 'min')"
        />
        <span>%</span>
      </label>
      <div class="track">
        <div class="fill" [style.width.%]="getPositionPercent(row)"></div>
        <div class="marker" [style.left.%]="getPositionPercent(row)"></div>
        <input
          class="slider-hit"
          type="range"
          [min]="row.min"
          [max]="row.max"
          [step]="getStep(row)"
          [value]="row.currentValue"
          (input)="onSlide(row, $event)"
        />
        <div class="value" [style.left.%]="getPositionPercent(row)">{{ formatDisplayValue(row.currentValue) }}%</div>
      </div>
      <label class="boundary max" aria-label="Maximum percentage">
        <input
          class="boundary-input"
          type="number"
          [(ngModel)]="row.max"
          [step]="getStep(row)"
          (ngModelChange)="onBoundaryChange(row, 'max')"
        />
        <span>%</span>
      </label>
    </div>
  </div>
  <ng-template #emptyState>
    <div class="empty">No APA ranges available.</div>
  </ng-template>
</div>
